<template>
  <TableCell
    :tag
    :cellColor
    :popoverTitle
    :selectedCells="selectedCells"
    v-model:showingPopover="showingPopover"
    v-model:columnSelectionCode="columnSelectionCode"
  >
    {{ cellText ?? tag.value }}

    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>

    <template #PopoverContentDesktop="{helpText}">
      <div style="display: flex; flex-direction: column; gap: 20px; align-items: center;">
        <h3>
          {{ popoverTitle }}
        </h3>
        <slot name="BinSelectionInput"></slot>
        <InputText ref="textInput" style="align-self: stretch; text-align: center;"
          v-model="textInputValue"
          @keypress.enter="submit()"
          @keypress.esc="close()"
          @keyboardPopoverOk="submit()"
          @keyboardPopoverCancel="close()"
        ></InputText>
        <div v-if="helpText">
          {{ helpText }}
        </div>
        <div style="display: flex; gap: 10px; width: 100%; justify-content: flex-end;">
          <Button severity="primary" style="width: 150px; height: 50px;" @click="submit()">
            Ok
          </Button>
          <Button severity="secondary" style="width: 150px; height: 50px;" @click="close()">
            Cancel
          </Button>
        </div>
      </div>
    </template>
  </TableCell>
</template>

<script setup>
import { ref, watch } from "vue";
import { promiseTimeout } from "@vueuse/core";
import { changeSettings } from "./appUtility";
import TableCell from "./TableCell.vue";

let props = defineProps([
  "tag",
  "cellText",
  "cellColor",
  "selectedCells",
  "showingPopover",
  "popoverTitle",
  "columnSelectionCode",
  "submitOverride"
]);

let showingPopover = defineModel("showingPopover");
let columnSelectionCode = defineModel("columnSelectionCode");

let textInputValue = ref();
watch(showingPopover, () => {
  if (showingPopover.value)
    textInputValue.value = props.tag.value;
});

let textInput = ref();
watch(showingPopover, async () => {
  if (showingPopover.value) {
    await promiseTimeout(60);
    textInput.value.$el.select();
  }
});

function submit() {
  showingPopover.value = false;
  if (props.submitOverride) {
    props.submitOverride(props.selectedCells, textInputValue.value);
  }
  else {
    changeSettings(props.selectedCells, cell => {
      return {
        handle: cell.componentArgs.tag.handle,
        value: textInputValue.value.trim()
      }
    });
  }
}

function close() {
  showingPopover.value = false;
}

</script>